import { render, staticRenderFns } from "./ArrowButtonMock.vue?vue&type=template&id=0528d3b4&scoped=true&"
import script from "./ArrowButtonMock.vue?vue&type=script&lang=ts&"
export * from "./ArrowButtonMock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528d3b4",
  null
  
)

export default component.exports